// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3SqwO","header":"PatientBlock_header__1Mhvb","label":"PatientBlock_label__TaFl6","option":"PatientBlock_option__3HRn1"};